/**
 * Data transformation utilities for API integration
 */
export { transformVisualizationChart as transformChartData } from "./chartDataBuilders";

/**
 * Parse formatted currency/number strings to numeric values
 * @param {*} value - Value to parse
 * @returns {number|*} Parsed numeric value or original value
 */
export function parseFormattedValue(value) {
  if (typeof value === 'string' && value.match(/[₹$€,]/)) {
    return parseFloat(value.replace(/[₹$€,]/g, ''));
  }
  return value;
}

/**
 * Convert query results with formatted strings to numeric values for visualization API
 * @param {Array} rawResults - Raw results from query API
 * @returns {Array} Results with numeric values
 */
export function prepareVisualizationData(rawResults) {
  if (!rawResults || !Array.isArray(rawResults)) {
    return [];
  }

  return rawResults.map(row => {
    const numericRow = {};
    Object.keys(row).forEach(key => {
      numericRow[key] = parseFormattedValue(row[key]);
    });
    return numericRow;
  });
}

/**
 * Check if query results are visualizable
 * @param {Object} queryResponse - Response from query API
 * @returns {boolean} True if data can be visualized
 */
export function hasVisualizableData(queryResponse) {
  return !!(
    queryResponse &&
    queryResponse.raw_results &&
    Array.isArray(queryResponse.raw_results) &&
    queryResponse.raw_results.length > 0 &&
    queryResponse.final_generated_sql_query
  );
}
